import { Search } from "lucide-react";
import type { Card, CardAction } from "../../types/chat";

interface Props {
  card: Card;
  onAction: (action: CardAction) => void;
}

export function SearchResultsCard({ card, onAction }: Props) {
  const results = (card.data.results as Array<Record<string, string>>) ?? [];
  const query = (card.data.query as string) ?? "";

  return (
    <div className="rounded-lg border bg-card p-3" role="region" aria-label="Search results">
      {query && (
        <p className="text-xs text-muted-foreground mb-2 flex items-center gap-1">
          <Search className="size-3" />
          Results for &ldquo;{query}&rdquo;
        </p>
      )}
      <div className="flex flex-col gap-1.5">
        {results.slice(0, 5).map((r, i) => (
          <div key={i} className="text-sm">
            <span className="font-medium">{r.title ?? r.subject ?? "Untitled"}</span>
            {r.snippet && <p className="text-xs text-muted-foreground truncate">{r.snippet}</p>}
          </div>
        ))}
      </div>
      {card.actions?.map((action) => (
        <button
          key={action.id}
          onClick={() => onAction(action)}
          className="mt-2 text-xs text-primary hover:underline"
        >
          {action.label}
        </button>
      ))}
    </div>
  );
}
